/* 
 *  Created by SGiri 02/14/2018
 */

import { Injectable } from "@angular/core";

@Injectable()
export class AppUtil {


  public getGridOptions(overlayMSg: string) {

    let overlayNoRowsTemplate = '<span class="ag-overlay-loading-center">' + overlayMSg + ' </span>';
    let overlayLoadingTemplate = '<span class=""></span>';

    return {
      enableSorting: true,
      getRowHeight: function (params) { return 27; },
      enableColResize: true,
      // suppressHorizontalScroll: true,
      defaultColDef: { editable: false },
      overlayLoadingTemplate: overlayLoadingTemplate,
      overlayNoRowsTemplate: overlayNoRowsTemplate,
      editType: 'fullRow',
      rowSelection: "single",
      //suppressClickEdit: true
      animateRows: true
    };
  }




  public dateFormatter(params) {
    var options = { month: 'short', day: '2-digit', year: 'numeric' };
    return new Date(params.value).toLocaleDateString("en-US", options)
  }

}


// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/util/app.util.ts